import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxsModule } from '@ngxs/store';
import {
    UserDelegationPickerDialogComponent
} from 'src/app/_user/dialogs/user-delegation-picker-dialog/user-delegation-picker-dialog.component';

import { UserRoutingModule } from 'src/app/_user/user.routing.module';
import { LoginComponent } from 'src/app/_user/pages/login/login.component';
import { LoginInformationsComponent } from 'src/app/_user/pages/login-informations/login-informations.component';
import { UserState } from 'src/app/_user/store/user/user.state';
import { AuthGuard } from 'src/app/_user/guards/auth.guard';
import { SharedModule } from 'src/app/_shared/shared.module';
import { MultiDelegationsComponent } from 'src/app/_user/components/multi-delegations/multi-delegations.component';
import { SuperAdminDialogComponent } from 'src/app/_user/dialogs/super-admin-dialog/super-admin-dialog.component';
import { UserDelegationPickerComponent } from 'src/app/_user/components/user-delegation-picker/user-delegation-picker.component';
import { MenuState } from 'src/app/_user/store/menu/menu.state';

@NgModule({
    declarations: [
        LoginComponent,
        LoginInformationsComponent,
        UserDelegationPickerComponent,
        MultiDelegationsComponent,
        SuperAdminDialogComponent,
        UserDelegationPickerDialogComponent
    ],
    imports: [
        UserRoutingModule,
        SharedModule,
        NgxsModule.forFeature([
            UserState,
            MenuState
        ])
    ],
    providers: [provideHttpClient(withInterceptorsFromDi())]
})
export class UserModule {
    static forRoot(): ModuleWithProviders<UserModule> {
        return {
            ngModule: UserModule,
            providers: [
                AuthGuard
            ]
        };
    }
}
